export default __webpack_public_path__ + "static/media/pen-search.2eb25209.png";